import { url_get_param } from "../../util/methods"

$(document).on("turbolinks:load", function () {
  var $priceList = $(".js-product-variantPriceList")

  if ($priceList.length > 0) {
    var $priceCart = $(".js-price-cart")
    var $variantContainer = $(".js-variant-container")
    var $variantPrices = $(".js-product-variantPrice")
    var queryStr = window.location.search
    var varId = url_get_param("variant")

    $variantPrices.on("change", function () {
      var $this = $(this)
      var price = $this.data("price")

      if ($this.is(":checked")) {
        $priceCart.text(price)
        $variantContainer.removeClass("active-variant")
        $variantContainer.addClass("active-variant")
      }
    })

    if (queryStr && varId) {
      $("#variant-" + varId).trigger("click")
    }
  }
})
